export const sanitizePhoneDigits = (value?: string): string =>
  typeof value === 'string' ? value.replace(/\D/g, '') : '';
